import { Button, Col, Row, Tag } from "antd";
import React, { Fragment } from "react";
import { useWindowDimensions } from "../../../../hooks/useDimensionHook";
import {
  TIME_SHEET_APPROVED_ACTION,
  TIME_SHEET_PENDING_ACTION,
  TIME_SHEET_REJECTED_ACTION,
} from "../../TimeSheetConstants";

const TimesheetActionButtonCol = ({
  status,
  handleApprove,
  handleReject,
  loading = false,
  disable,
  okButtonText = "Approve",
  cancelButtonText = "Reject",
}) => {
  const getTimeSheetCol = () => {
    switch (status) {
      case TIME_SHEET_PENDING_ACTION:
        // if (width <= 768)
        return (
          <Row gutter={[10, 8]} justify="center">
            <Col
              span={12}
              style={{
                display: "flex",
                justifyContent: "center",
                height: "30px",
              }}
            >
              <Button
                onClick={handleApprove}
                style={{
                  padding: "17px 0px",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                size="small"
                loading={loading}
                disabled={disable || loading}
              >
                {okButtonText}
              </Button>
            </Col>
            <Col
              span={12}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Button
                onClick={handleReject}
                style={{
                  padding: "17px 0px",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                size="small"
                loading={loading}
                disabled={disable || loading}
              >
                {cancelButtonText}
              </Button>
            </Col>
          </Row>
        );
      case TIME_SHEET_APPROVED_ACTION:
        return (
          <Row>
            <Tag
              color="success"
              className="full-width"
              style={{ padding: "2px 7px" }}
            >
              Approved
            </Tag>
          </Row>
        );
      case TIME_SHEET_REJECTED_ACTION:
        return (
          <Tag
            color="error"
            className="full-width"
            style={{ padding: "2px 7px" }}
          >
            Rejected
          </Tag>
        );
      default:
        return <p>N/A</p>;
    }
  };
  const { width } = useWindowDimensions();
  if (width <= 768) return <Col span={24}>{getTimeSheetCol()}</Col>;
  return <Fragment>{getTimeSheetCol()}</Fragment>;
};

export { TimesheetActionButtonCol };
